function e(e,r){var t;return"string"==typeof e?r?(null!==(t=r[e])&&void 0!==t||(r[e]=document.querySelectorAll(e)),e=r[e]):e=document.querySelectorAll(e):e instanceof Element&&(e=[e]),Array.from(e||[])}export{e as resolveElements};
